'use client';

import clsx from 'clsx';
import { FC } from 'react';
import { useState } from 'react';

import { FaqSectionDto } from '@/components/service-pages/Faq/types';
import TitleGraffiti from '@/components/shared/TitleGraffiti';
import { Typography } from '@/components/shared/Typography';
import StrapiRichContent from '@/components/StrapiRichContent';

import css from './style.module.scss';

const ActivatorIcon: FC = () => (
	<svg
		className={css.activatorIcon}
		width="20"
		height="20"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path d="M2 5L8 11L14 5" stroke="currentColor" strokeWidth="2" />
	</svg>
);

interface Props {
	data: FaqSectionDto;
}

const Faq: FC<Props> = ({ data }) => {
	const [activeIndex, setActiveIndex] = useState<number | null>(null);
	const isIndustry = data.isIndustry ?? true;

	const toggleAccordion = (index: number) => {
		setActiveIndex(prev => (prev === index ? null : index));
	};

	return (
		<section className={clsx(css.section, 'container')}>
			<TitleGraffiti
				className={css.titleWrapper}
				isIndustry={isIndustry}
				url="/assets/video/mov/graffiti/faq.mov"
				title={data.title}
				typography={{
					className: css.title
				}}
			/>

			{data.faqItems.map((item, index) => (
				<div key={index} className={clsx(css.accordeonItem, activeIndex === index && css.opened)}>
					<button className={css.activator} onClick={() => toggleAccordion(index)}>
						<ActivatorIcon />
						<Typography
							uppercase
							variant={isIndustry ? 'h3-industry' : 'h5'}
							tag="h2"
							className={clsx(css.activatorTitle, isIndustry && css.industry)}
						>
							{item.question}
						</Typography>
						<ActivatorIcon />
					</button>

					<div className={css.contentShell}>
						<div className={css.content}>
							<Typography
								variant="body-m"
								tag="div"
								className={clsx(css.inner, isIndustry && css.industry)}
							>
								<StrapiRichContent content={item.answer} />
							</Typography>
						</div>
					</div>
				</div>
			))}
		</section>
	);
};

export default Faq;
